import React, { createContext, useContext, useState } from "react";

const EditStateContext = createContext();

export const EditStateProvider = ({ children }) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <EditStateContext.Provider value={{ isEditing, setIsEditing }}>
      {children}
    </EditStateContext.Provider>
  );
};

export const useEditState = () => useContext(EditStateContext);
